export default {
    productosArray: [],
    menus: [],
    gruposModificadores: [],
    modificadores: [],
    tarifas: [],
    categoriaFiltrar: null,
    //edición de productos
    viendoOpciones: false,
    productoEditando: null,
    opcionesEditadas: null,
    //catálogos a editar
    busqueda: '',
    busquedaMenu: ''

}